var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lw-tab-pane"},_vm._l((_vm.component.components),function(child,index){return _c(child.is,{key:index,tag:"component",attrs:{"component":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }